import { graphql } from 'gatsby'
import React, { useEffect, useState } from 'react'
import { useShopStoreIncontext } from '../../../context/shopContext'
import { UpsellGift, CartAddToCartModules } from './components'

const useShopPanelData = (data) => {
  const { stock: contextStock, storeLocale } = useShopStoreIncontext(
    (state) => {
      return {
        stock: state.stock,
        storeLocale: state.storeLocale,
      }
    }
  )
  let sharedData = data.shared

  let stock = JSON.parse(data?.stock?.skus || {})
  if (contextStock[storeLocale] != null) {
    stock = contextStock[storeLocale]
  }

  const filledTiles = sharedData?.UpsellModule?.map((items, index) => {
    let strapiProductVariants = items?.upsell_products?.[0]?.Variants?.map((variant) => ({
      ...variant,
    }))


    let filteredStrapiProductVariants = strapiProductVariants?.reduce((accumulator, currentValue) => {
      if (
        stock[currentValue.SKU] &&
        stock[currentValue.SKU].avaliable === true &&
        stock[currentValue.SKU].on_site === true
      ) {
        accumulator.push(currentValue)
      }
      return accumulator
    }, [])

    const item = { ...items.upsell_products?.[0], Variants: filteredStrapiProductVariants, discount: items?.discountAmount || 0 }
    const categories = items.product_category?.CategoryName

    return { item, categories }
  })
  return {
    upsellModuleData: filledTiles,
    sharedData: sharedData,
  }
}
const findUpsellProduct = (cart, upsellModuleData) => {
  let foundProduct = undefined
  let includesUpsell = false
  let cartUpsellOrder = cart?.map((cartItem) => cartItem.title)

  cart?.map((val) => {
    if (val.upsellItem == true) {
      includesUpsell = true
    }

    upsellModuleData?.map((upsell) => {
      val.product_categories?.map((item) => {
        if (
          !cartUpsellOrder.includes(upsell.item.Title) &&
          foundProduct === undefined &&
          item === upsell.categories &&
          upsell.item?.Variants?.length > 0
        ) {
          foundProduct = upsell.item
        }
      })
    })
  })
  if (includesUpsell == true) {
    return undefined
  }

  return foundProduct
}
const calculatePricing = (checkout) => {
  if (!checkout?.lineItems)
    return {
      sumPrice: 0,
      nonPerSubPriceList: 0,
    }
  let sumPrice = 0
  let nonPerSubPriceList = checkout?.lineItems.edges.map(({ node }) => {
    let lineItem = node
    let netPrice =
      (parseFloat(lineItem.variant?.price?.amount ? lineItem.variant?.price?.amount : '').toFixed(2) || 0) *
      lineItem.quantity
    if (lineItem['discountAllocations'] && lineItem['discountAllocations'].length > 0) {
      lineItem['discountAllocations'].map((discountAllocation) => {
        if (discountAllocation['discountApplication']['title'] === 'Free Personalisation') {
          netPrice += parseFloat(discountAllocation['allocatedAmount']['amount'])
        }
      })
    }
    if (lineItem.variant.sku.includes('freight')) {
      return 0
    }
    return netPrice
  })
  try {
    sumPrice = nonPerSubPriceList.reduce((accumulator, a) => accumulator + a, 0)
  } catch (e) {
    console.log(e)
  }
  return {
    sumPrice,
    nonPerSubPriceList,
  }
}

const UpsellModule = ({ data, sliceContext }) => {
  const storeLocale = sliceContext.locale

  const { cart, checkout, setCartOpen, setUpsellGiftActive } = useShopStoreIncontext((state) => {
    return {
      cart: state.cart,
      checkout: state.checkout,
      setCartOpen: state.actions.setCartOpen,
      setUpsellGiftActive: state.actions.setUpsellGiftActive,
    }
  })

  const closeCart = () => {
    setCartOpen(false)
  }
  const {
    upsellModuleData,
    sharedData
  } = useShopPanelData(data)

  const [selectedUpsellProduct, setSelectedUpsellProduct] = useState({})
  const { sumPrice } = calculatePricing(checkout)

  useEffect(() => {
    setSelectedUpsellProduct(findUpsellProduct(cart, upsellModuleData))
  }, [cart])

  // const weekenderUpsellProducts = sharedData?.UpsellModule?.slice(0, 4)
  /* BUNDLE AND SAVE */
  // if (sharedData?.hideBundlePricing) {
  //   return (
  //     <>
  //       <CompleteText> <b> BUNDLE & SAVE </b> </CompleteText>
  //       <ProgressBar itemCount={cart?.map(val => [val.variantQuantity, val.id])} total={sumPrice} storeLocale={storeLocale} />
  //       <div style={{ display: checkout?.lineItems ? 'block' : 'none' }}>
  //         {(selectedUpsellProduct !== undefined && cart?.length > 0 && checkout?.subtotalPrice?.amount < 1000) && <>
  //           <CompleteText> Add more to your cart to access the savings. </CompleteText>
  //           <CartAddToCartModules
  //             refresh={!(checkout?.lineItems && checkout?.lineItems.length > 0)}
  //             closeCart={closeCart}
  //             product={selectedUpsellProduct}
  //             hideBundlePricing={sharedData?.hideBundlePricing || false}
  //             storeLocale={storeLocale}
  //           />
  //         </>}
  //       </div>
  //     </>
  //   )
  // }

  // const settings = {
  //   dots: false,
  //   infinite: true,
  //   speed: 600,
  //   slidesToShow: 1,
  //   slidesToScroll: 1,
  //   autoplay: false,
  //   adaptiveHeight: true,
  //   fade: false,
  //   prevArrow: <ArrowImage src={ArrowLeft} />,
  //   nextArrow: <ArrowImage src={ArrowRight} />,
  //   responsive: [
  //     {
  //       breakpoint: 1027,
  //       settings: {
  //         slidesToShow: 1,
  //         slidesToScroll: 1,
  //         infinite: true,
  //         dots: true,
  //         arrows: true,
  //       }
  //     },
  //     {
  //       breakpoint: 600,
  //       settings: {
  //         slidesToShow: 1,
  //         slidesToScroll: 1,
  //         infinite: true,
  //         dots: false,
  //         arrows: true,
  //       }
  //     },
  //     {
  //       breakpoint: 480,
  //       settings: {
  //         slidesToShow: 1,
  //         slidesToScroll: 1,
  //         infinite: true,
  //         dots: false,
  //         arrows: true,
  //       }
  //     }
  //   ]
  // };

  // const hasLuggage = cart?.some(product =>
  //   product?.product_categories?.includes('Luggage')
  // );

  const promoPricingLookup = {
    en: 350,
    'en-NZ': 500,
    'en-AU': 400,
    'en-CA': 450,
  }

  // Update upsell gift active state based on the condition
  useEffect(() => {
    const isUpsellGiftActive = promoPricingLookup[storeLocale] && sharedData?.UpsellModule[0]?.product_category?.CategoryName === 'UpsellGift'
    
    setUpsellGiftActive(!!isUpsellGiftActive)
  }, [storeLocale])

  return (
    <>
      {
        (promoPricingLookup[storeLocale] && Number(checkout?.subtotalPrice?.amount) > promoPricingLookup[storeLocale] && selectedUpsellProduct !== undefined && cart.length > 0 && sharedData?.UpsellModule[0]?.product_category?.CategoryName === 'UpsellGift') ? (
          <UpsellGift
            pricing={promoPricingLookup[storeLocale]}
            refresh={!(checkout.lineItems && checkout.lineItems.length > 0)}
            closeCart={closeCart}
            product={sharedData?.UpsellModule[0]?.upsell_products[0]}
            hideBundlePricing={sharedData?.hideBundlePricing || false}
            discount={sharedData?.UpsellModule[0]?.discountAmount}
          />
        ) : (
          <div style={{ display: checkout.lineItems ? 'block' : 'none' }}>
            {(selectedUpsellProduct !== undefined && cart.length > 0) &&
              <CartAddToCartModules
                refresh={!(checkout.lineItems && checkout.lineItems.length > 0)}
                closeCart={closeCart}
                product={selectedUpsellProduct}
                hideBundlePricing={sharedData?.hideBundlePricing || false}
                shared={data.shared}
              />
            }
          </div>
        )
      }
    </>
  )
}

export default UpsellModule

export const query = graphql`
  query ($locale: String) {
    shared: strapiShared (locale: { eq: $locale }) {
      UpsellModule {
        upsell_products {
          Title
          product_categories { 
            CategoryName
          }
          shopifyInfo {
            ... on UKShopifyProduct {
              shopifyId
            }
            ... on NZShopifyProduct {
              shopifyId
            }
            ... on USShopifyProduct {
              shopifyId
            }
            ... on CAShopifyProduct {
              shopifyId
            }
            ... on AUShopifyProduct {
              shopifyId
            }
          }

          Variants {
            shopifyInfo {
              ... on UKShopifyProductVariant {
                shopifyId
                price
                image {
                  gatsbyImageData(width: 200)
                }
              }
              ... on NZShopifyProductVariant {
                shopifyId
                price
                image {
                  gatsbyImageData(width: 200)
                }
              }
              ... on USShopifyProductVariant {
                shopifyId
                price
                image {
                  gatsbyImageData(width: 200)
                }
              }
              ... on CAShopifyProductVariant {
                shopifyId
                price
                image {
                  gatsbyImageData(width: 200)
                }
              }
              ... on AUShopifyProductVariant {
                shopifyId
                price
                image {
                  gatsbyImageData(width: 200)
                }
              }
            }
            Colour
            ColourName
            SKU
            ShopTileImage {
              ...Image
            }
            personaliseInfo
          }
          handle
          locale
        }
        product_category {
          CategoryName
        }
        discountAmount
      }
      locale
      SignUpId
      FreePersonalisation
      discountPromoOn
      FreeSuitcasePersonalisation
      hideBundlePricing
    }
    stock(locale: { eq: $locale }) {
      skus
    }
  }
`
